import { compose, entries, get, identity, map, toNumber } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getStringProp } from '@mews/fp';
import { getSelectedEntityId } from '../../entityManagement/selectors';
import { DEFAULT_SERVICE_INDEX } from '../constants';
import { moduleSelector } from '../module';

const parentCategoriesSelector = createSelector(moduleSelector, get('categoriesStep'));

export const getCategories = compose(get('categories'), parentCategoriesSelector);

export const getCategoriesOrdering = compose(get('categoryOrdering'), parentCategoriesSelector);

export const getSelectedCategory = createSelector(
    getCategories,
    getSelectedEntityId,
    (categories, id) => categories[id]
);

export const getSelectedCategoryName = compose(get('name'), getSelectedCategory);

export const getSelectedCategoryId = compose(get('id'), getSelectedCategory);

export const getCategoryById = createSelector(getCategories, getStringProp('id'), (categories, id) => categories[id]);

export const getCategoryNameById = compose(get('name'), getCategoryById);

export const getCategoryCapacityById = compose(get('capacity'), getCategoryById);

export const getCategoryShortcut = compose(get('shortcut'), getCategoryById);

export const getCategoryResourceCategoryTypeById = compose(get('resourceCategoryType'), getCategoryById);

export const getAllOrderedCategories = createSelector(getCategoriesOrdering, identity, (ordering, state) =>
    // @ts-expect-error $TSFixMeError: Argument of type 'LodashMap1x1<unknown, any>' is not assignable to parameter of type 'Many<(...args: any[]) => any>[]'.
    map((id) => getCategoryById(state, { id }))(ordering)
);

export const getCategoriesExportData = compose(
    map(([index, { shortcut, ...otherData }]) => ({
        shortName: shortcut,
        ordering: toNumber(index),
        serviceIndex: DEFAULT_SERVICE_INDEX,
        ...otherData,
    })),
    entries,
    getAllOrderedCategories
);
